import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { times } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { getShapeHelper } from '../../shape-helpers/get-shape-helper';

interface Line {
  p1: Point2D;
  p2: Point2D;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3InteractiveBorder]',
  templateUrl: './interactive-border.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InteractiveBorderComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) shapeStore!: Store<ShapeState2D>;
  @Input({ required: true }) points$!: Observable<Point2D[]>;
  lines$!: Observable<Line[]>;

  trackByIndex = (index: number) => index;

  ngOnInit() {
    this.lines$ = this.buildLines$();
  }

  private buildLines$() {
    const shapeHelper = getShapeHelper(this.shapeStore.state().type);
    return this.points$.pipe(
      map((points) =>
        times(shapeHelper.getNumberOfLines(points), (i) => ({
          p1: points[i],
          p2: points[(i + 1) % points.length],
        })),
      ),
    );
  }
}
